import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "pr-2" }
const _hoisted_3 = { class: "d-flex align-items-center lh-1" }
const _hoisted_4 = { class: "ml-3" }

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import {computed, ref} from "vue";
import TagInterface from "~/cabinet/vue/interface/form/tags/TagInterface";
import ReactiveFilterableListRequest from "~/core-ui/ts/request/ReactiveFilterableListRequest";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {predefineColors} from "~/core-ui/ts/CoreUiHelpersMixin";
import {IOptionGroup} from "~/cabinet/vue/interface/form/elements/Interfaces";
import MyRemoteDataCards from "~/cabinet/vue/interface/data/MyRemoteDataCards.vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import MyColorPicker from "~/core-ui/vue/ui/MyColorPicker.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import HelpIcon from "~/cabinet/vue/interface/form/HelpIcon.vue";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "TagsConfigDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    tagTypeId: {},
    availableForOptionGroups: {},
    showAiDescription: { type: Boolean }
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let isVisible = _useModel<boolean>(__props, "visible");


let tagConfigRequest = computed(() => {
    return new ReactiveFilterableListRequest(new LcabApiRequest({
        url: `/api/ui/tag/${props.tagTypeId}/getListForConfigDialog`
    }));
});

let changedList = computed<TagInterface[]>(() => {
    return (tagConfigRequest.value.data as any).changedList;
});


async function saveTag(tag: TagInterface) {
    let result = await LcabApiRequest.save({
        url: `/api/ui/tag/${props.tagTypeId}/saveTag`,
        p: tag
    });
    if (result.isSuccess) {
        addTagDialog.value = null;
        if (!tag.cc) {
            tagConfigRequest.value.make();
        } else {
            toggleArrayElement(changedList.value, tag, false);
        }
        emits("update");
    }
}

async function deleteTag(tag: TagInterface) {
    try {
        await ElConfirm("Точно удаляем этот тэг?");
        let result = await LcabApiRequest.save({
            url: `/api/ui/tag/${props.tagTypeId}/${tag.cc}/deleteTag`,
        });
        if (result.isSuccess) {
            tagConfigRequest.value.make();
            emits("update");
        }
    } catch (e) {

    }
}


let addTagDialog = ref<{
    visible: boolean,
    model: TagInterface;
}>();

function showAddTagDialog() {
    addTagDialog.value = {
        visible: true,
        model: {
            tag: null,
            color: null,
            cc: null,
            availableFor: []
        }
    };
}

function r(tag: TagInterface) {
    return tag;
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      class: _normalizeClass({
                'right body-background full-height-body': true,
                'w-75': __props.availableForOptionGroups?.length > 0
            }),
      title: "Управление тэгами",
      modelValue: _unref(isVisible),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { class: "el-row-root" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _createVNode(ElCardSection, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: showAddTagDialog
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Добавить тэг ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(MyRemoteDataCards, {
                  request: _unref(tagConfigRequest),
                  "row-key": "cc"
                }, {
                  default: _withCtx(({item}) => [
                    _createVNode(_component_el_card, null, {
                      default: _withCtx(() => [
                        _createVNode(ElCardHeader, { "button-col-span": 6 }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createElementVNode("div", _hoisted_2, [
                                _createVNode(MyColorPicker, {
                                  modelValue: r(item).color,
                                  "onUpdate:modelValue": [($event: any) => ((r(item).color) = $event), ($event: any) => (_unref(toggleArrayElement)(_unref(changedList), item, true))],
                                  predefine: _unref(predefineColors),
                                  class: "h-auto"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "predefine"])
                              ]),
                              _createElementVNode("div", null, _toDisplayString(r(item).tag), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button_group, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  disabled: !_unref(changedList).includes(item),
                                  type: _unref(changedList).includes(item) ? 'primary' : null,
                                  onClick: ($event: any) => (saveTag(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(FontAwesomeIcon, { icon: "save" })
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "type", "onClick"]),
                                _createVNode(_component_el_button, {
                                  onClick: ($event: any) => (deleteTag(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(FontAwesomeIcon, { icon: "trash" })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (__props.availableForOptionGroups?.length > 0 || __props.showAiDescription)
                          ? (_openBlock(), _createBlock(ElCardSection, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form, {
                                  "label-position": "left",
                                  "label-width": "180px"
                                }, {
                                  default: _withCtx(() => [
                                    (__props.availableForOptionGroups?.length > 0)
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          label: "Права доступа к тэгу"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: r(item).availableFor,
                                              "onUpdate:modelValue": [($event: any) => ((r(item).availableFor) = $event), ($event: any) => (_unref(toggleArrayElement)(_unref(changedList), item, true))],
                                              multiple: "",
                                              placeholder: "Доступно всем",
                                              filterable: "",
                                              clearable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableForOptionGroups, (group) => {
                                                  return (_openBlock(), _createBlock(_component_el_option_group, {
                                                    label: group.descr
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          label: option.descr,
                                                          value: option.value
                                                        }, null, 8, ["label", "value"]))
                                                      }), 256))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label"]))
                                                }), 256))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_form_item, null, {
                                      label: _withCtx(() => [
                                        _cache[8] || (_cache[8] = _createTextVNode(" Описание для AI ", -1)),
                                        _createVNode(HelpIcon, { class: "ml-2" }, {
                                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createTextVNode(" Подскажите AI-ассистенту, в каких случаях должен проставляться этот тэг ", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: r(item).description,
                                          "onUpdate:modelValue": [($event: any) => ((r(item).description) = $event), ($event: any) => (_unref(toggleArrayElement)(_unref(changedList), item, true))],
                                          type: "textarea",
                                          autosize: {minRows: 1, maxRows: 6},
                                          placeholder: "Необязательно"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["request"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "modelValue"]),
    (_unref(addTagDialog) && _unref(addTagDialog).visible)
      ? (_openBlock(), _createBlock(MyDialog, {
          key: 0,
          visible: _unref(addTagDialog).visible,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addTagDialog).visible) = $event)),
          form: {
                    model: _unref(addTagDialog).model,
                    labelPosition: 'left',
                    labelWidth: '150px'
                },
          title: "Добавление тэга",
          onApply: _cache[5] || (_cache[5] = ($event: any) => (saveTag(_unref(addTagDialog).model)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Тэг" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addTagDialog).model.tag,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(addTagDialog).model.tag) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Цвет" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createVNode(MyColorPicker, {
                      modelValue: _unref(addTagDialog).model.color,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addTagDialog).model.color) = $event)),
                      class: "h-auto",
                      predefine: _unref(predefineColors)
                    }, null, 8, ["modelValue", "predefine"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    (_unref(addTagDialog).model.color)
                      ? (_openBlock(), _createBlock(MyIconButton, {
                          key: 0,
                          delete: "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(addTagDialog).model.color = null))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "form"]))
      : _createCommentVNode("", true)
  ]))
}
}

})